// these imports are removed via vite.config.json at the client
import './core/core.permissions.ts'
import './contract/contract.permissions.ts'
import './trade-hub/trade-hub.permissions.ts'

export enum RT {
	USER = 'user',
	ROLE = 'role',
	CLIENT = 'client',
	CLIENTASSIGNMENT = 'clientassignment',
	MARKETPLACE = 'marketplace',
	PROVIDER = 'provider',
	PRODUCT = 'product',
	OPTION = 'option',
	MEDIA = 'media',
	CONTRACT = 'contract',
	CONTRACTOR = 'contractor',
	CONTRACTSEQUENCE = 'contractsequence',
	CONTRACTTEMPLATE = 'contracttemplate',
	// Trade Hub resources
	TOUROPERATORCUSTOMER = 'touroperatorcustomer',
	B2BPARTNER = 'b2bpartner',
	B2BPARTNERUSER = 'b2bpartneruser',
	TOUROPERATORCONTRACT = 'touroperatorcontract',
	INVITATION = 'invitation',
	TICKETASSIGNMENT = 'ticketassignment',
	GENERALPROVISION = 'generalprovision',
	SPECIFICPROVISION = 'specificprovision',
	// ...
}